/** @jsx jsx */
import { jsx } from "theme-ui"

import * as redlyst from '../../../components/redlyst.module.css'
import pp from '../../../components/me.jpg'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
// import { faFacebookF, faFacebook } from '@fortawesome/free-brands-svg-icons'
import { faInstagramSquare } from '@fortawesome/free-brands-svg-icons'
import { faTwitterSquare } from '@fortawesome/free-brands-svg-icons'
import { faGithubSquare } from '@fortawesome/free-brands-svg-icons'
// import { faLinkedinIn } from '@fortawesome/free-brands-svg-icons'

const AboutMe = () => {

    return (
        <div className={redlyst.div}>
            <div className={redlyst.introText}>
                <p className={redlyst.p1}>Hi, I'm AKBAR.</p>
                {/* <p className={redlyst.p1}>Hi, I'm AKBAR,<br></br>a full stack mobile developer.</p> */}
                {/* <p> I'm a fullstack mobile developer.</p> */}
                {/* <p className={redlyst.p2}>
                    This website is my digital garden—a compendium of the things I have learned and anything else I want to write about.<br></br> You can read my<a className={redlyst.link} href="/blog">blog,</a>view my<a className={redlyst.link} href="/tags/tutorial">guides</a>or learn more<a className={redlyst.link} href="/about">about me.</a></p> */}
                {/* <p className={redlyst.p2}>
                    This website is my digital garden—a compendium of the things I have learned and anything else I want to write about.<br></br> You can read my<a className={redlyst.link} href="/blog">blog</a>or view my<a className={redlyst.link} href="/tags/tutorial">guides.</a></p> */}
                <p className={redlyst.p2}>
                    This website is my digital garden—a compendium of the things I have learned and anything else I want to write about.</p>
                <p className={redlyst.p3}>For business enquiries or casual chatter—do drop me a line at id.redlyst@gmail.com.</p>
            </div>
            <div className={redlyst.introPict}>
                <section>
                    <img className={redlyst.img} src={pp} alt="Muhammad Akbar" /></section>

                <section className={redlyst.media}>
                    <a className={redlyst.link} href="https://github.com/redlyst">
                        <FontAwesomeIcon icon={faGithubSquare} size="lg" />
                    </a>
                    {/* <a className={redlyst.link} href="#">
                        <FontAwesomeIcon icon={faLinkedinIn} />
                    </a> */}
                    <a className={redlyst.link} href="https://www.instagram.com/mh.akbaar/">
                        <FontAwesomeIcon icon={faInstagramSquare} size="lg" />
                    </a>
                    <a className={redlyst.link} href="https://twitter.com/mh_akbaar">
                        <FontAwesomeIcon icon={faTwitterSquare} size="lg" />
                    </a>
                    {/* <a className={redlyst.link} href="#">
                        <FontAwesomeIcon icon={faFacebookF} />
                    </a> */}
                </section>

            </div>
        </div>
    )
}

export default AboutMe
